import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d4f5c6d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-black" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  width: "240",
  src: "https://static-s.theckb.com/BusinessMarket/Client/icon_blacklist.png",
  alt: ""
}, null, -1))
const _hoisted_3 = { class: "tip" }

import { t } from '@/plugins/i18n'
import { useRouter } from 'vue-router'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const jump = () => {
  router.push('/')
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('很遗憾，这个商品不符合日本代购条件，可以看看其他商品')), 1),
    _createVNode(_component_el_button, {
      type: "primary",
      round: "",
      class: "signin",
      onClick: jump
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_unref(t)('回到首页')), 1)
      ]),
      _: 1
    })
  ]))
}
}

})